import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";

export interface HiePullStatusResponse {
  inProgress: boolean;
  workflowId: string;
  runId: string | null;
  status: string | null;
}

export const useHiePullStatus = (patientId: string, enabled: boolean) => {
  return useApi<HiePullStatusResponse>({
    queryOptions: {
      enabled,
      staleTime: 0,
      queryKey:
        QueryKeys.Patient.MedicalRecords.MetriportHIE.PULL_STATUS(patientId),
      queryFn: async () => {
        const response = await axiosInstance.get<HiePullStatusResponse>(
          `/charting/hie/pull/${patientId}`,
        );
        return response.data;
      },
      refetchInterval: (query) =>
        query.state.data?.inProgress ? 15_000 : false,
    },
  });
};
